import React, { useEffect, useMemo, useState } from "react";
import { ViewTaskProps } from "./view-task-props";
import "./view-task.scss";
import { formatDate, formatDateTime } from "../../../../../../../utils/utils";
import { getTaskById } from "../../../../../../../api/campaign";
import { useSetLoading } from "../../../../../../../common/hooks/appearance";
import { getFullName } from "../common-dialog-task/common-dialog-helper";
const TaskView: React.FC<ViewTaskProps> = (props: any) => {
  const { taskId, leadDetails } = props;
  const [task, setTask] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [loading, setLoading] = useState(false);
  const fetchTaskDetails = async () => {
    setLoading(true);
    try {
      const response = await getTaskById(
        taskId,
        leadDetails.id,
        "View Campaigns"
      );
      setTask(response?.data?.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while fetching the lead."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };
  useEffect(() => {
    if (taskId && leadDetails?.id) {
      fetchTaskDetails();
    }
  }, [taskId, leadDetails]);
  const showLoading = useMemo(() => loading, [loading]);
    useSetLoading(showLoading);
    console.log("leadDetails", leadDetails);
  return (
    <div className="lead-view-task-view">
      <div className="lead-list-view-details-view-box-full-info">
        <div className="lead-list-view-details-view-box-full-info-data">
          <div className="lead-list-view-details-view-box-full-info-data-section">
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Subject
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {task?.subject || "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Due Date
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                 {formatDate(task?.due_date) || "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Related To
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {getFullName(leadDetails.first_name, leadDetails.middle_name, leadDetails.last_name) || ""}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Reminder
              </div>
              {task?.reminder != null
                ? `On ${formatDateTime(task.reminder, true)}`
                : "-"}
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Created by
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {task?.createdBy
                  ? `${task.createdBy.first_name} ${task.createdBy.last_name}`
                  : "-"}
                <br />
                {formatDateTime(task?.created_at || "-", true)}
              </div>
            </div>
          </div>
          <div className="lead-list-view-details-view-box-full-info-data-section">
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Owner
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {task?.owner
                  ? `${task.owner.first_name} ${task.owner.last_name}`
                  : "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Priority
              </div>
              {task?.priority || "-"}
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Status
              </div>
              {task?.status || "-"}
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Closed Time
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {task?.closed_time != null
                  ? `On ${formatDateTime(task.closed_time, true)}`
                  : "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Modified By
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {task?.updatedBy
                  ? `${task.updatedBy.first_name} ${task.updatedBy.last_name}`
                  : "-"}
                <br />
                {formatDateTime(task?.updated_at || "-", true)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lead-list-view-details-view-box-full-info description-task">
        <div className="lead-list-view-details-view-box-full-info-header-text">
          Description
        </div>
        <div className="lead-list-view-details-view-box-full-info-description-box description-box-container">
          {task?.description || "-"}
        </div>
      </div>
    </div>
  );
};

export default TaskView;
